import { observable, action } from 'mobx';
import { IContentCreatorItem } from '../../../interfaces/IContentCreatorItem';
import { IInstance } from '../../../interfaces/IInstance';
import { IUser } from '../../../interfaces/IUser';
import { ITemplate } from '../../../interfaces/templates/ITemplate';

export class ContentCreatorStore {

  ////////////////////////////////// Component properties //////////////////////////////////

  @observable public tenant: string;
  @observable public instance: IInstance;
  @observable public token: string;
  @observable public environment: "Development" | "Test" | "Production";
  @observable public isMobile: boolean;
  @observable public marginTop: number;
  @observable public user: IUser;
  @observable public highlightColor: string;

  ///////////////////////////////////////// Items /////////////////////////////////////////

  @observable public id: number;
  @observable public title: string;
  @observable public items: IContentCreatorItem[];
  @observable public loading: boolean;
  @observable public isSaving: boolean;
  @observable public itemToEdit: IContentCreatorItem;
  @observable public itemToEditOriginal: IContentCreatorItem;
  @observable public itemToEditIndex: number;
  @observable public isCreatingNewItem: boolean;
  @observable public availableInstancesForComponent: any[];
  @observable public availableCategoriesForComponent: any[];
  @observable public loadingInstances: boolean;
  @observable public loadingCategories: boolean;
  @observable public showCancelEditPopup: boolean;
  @observable public availableTemplatesForInstance: ITemplate[];

  @action public createNewItem(): void {
    this.isCreatingNewItem = true;
    this.itemToEdit = {
      icon: "Plus"
    };
  }

  @action public delete(): void {
    let selectedIndex: number;
    this.items.forEach((item: IContentCreatorItem, index) => {
      if (item === this.itemToEdit) {
        selectedIndex = index;
      }     
    });
    this.items.splice(selectedIndex, 1);
  }

  ////////////////////////////////////// Drag'n'drop //////////////////////////////////////

  @observable public isDraggingItemWithIndex: number;
  @observable public draggedOverItemIndex: number;

  @action public addDroppableItemAtIndex(index: number) {
    console.log(index);
    // this.items.splice(index, 0, );
  }

  @action public isDraggingOverItemWithIndex(index: number) {
    if (index !== this.isDraggingItemWithIndex) {
      this.items = this.swapArrayElements(this.items, index, this.isDraggingItemWithIndex);
      this.isDraggingItemWithIndex = index;
    }
  }

  private swapArrayElements(a, x, y): any {
    if (a.length === 1) {
      return a;
    }
    a.splice(y, 1, a.splice(x, 1, a[y])[0]);
    return a;
  }

}